// extracted by mini-css-extract-plugin
export var emptyState = "_5x-d";
export var statCard = "_5x-c";
export var table = "_5x-0";
export var tableCell = "_5x-4";
export var tableCellClickable = "_5x-5 _5x-4";
export var tableCellDefault = "_5x-6 _5x-4";
export var tableCellEmpty = "_5x-8";
export var tableCellWithValue = "_5x-7";
export var tableContainer = "_5x-e";
export var tableHeaderWeight = "_5x-1";
export var tableHeaderZone = "_5x-2";
export var tableRowHeader = "_5x-3";
export var viewModeButton = "_5x-9";
export var viewModeButtonActive = "_5x-a _5x-9";
export var viewModeButtonInactive = "_5x-b _5x-9";